// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__2HaiG","video":"Video_video__2z4PT","hidden":"Video_hidden__3-Jpa","loading":"Video_loading__jJzXW"};